import React from 'react';

export const CardHoverContext = React.createContext({});
